<template>
  <div v-if="isReportTab" class="jmreport-report-page">
    <iframe
      class="jmreport-report-page__iframe"
      :src="reportPath"
      frameborder="0"
    />
  </div>
  <cargo-left-right-resize
    v-else
    :left-style="{ flex: '1 1 auto', width: '100%', 'max-width': 'none' }"
    :right-style="{ display: 'none' }"
    style="min-height: 100%;"
    @onSize="resizeCache = $event"
  >
    <template slot="left">
      <div v-loading="loading" class="jmreport-left">
        <div class="jmreport-left__filter">
          <el-input
            v-model="filterText"
            class="jmreport-left__search"
            size="small"
            clearable
            placeholder="搜索报表"
          />
          <el-button size="mini" type="primary" @click="toDesignReport">设计报表</el-button>
        </div>
        <el-tree
          ref="tree"
          class="jmreport-left__tree"
          :data="treeData"
          :props="treeProps"
          node-key="uuid"
          highlight-current
          default-expand-all
          :filter-node-method="filterNode"
          @node-click="onNodeClick"
        />
      </div>
    </template>

    <template slot="right" />
  </cargo-left-right-resize>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize.vue'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import checkPermission from '@/utils/permission'
import { getToken, getUserInfo } from '@/utils/auth'
import { appendCurrentToken } from './jmReportToken'
import { getJmReportMenuTree } from '@/api/jmReport'
import { filterMenuTreeByPermission } from './jmReportTree'

const JM_REPORT_MENU_ID = 5100

export default {
  name: 'JmReport',
  components: { cargoLeftRightResize },
  data() {
    return {
      loading: false,
      filterText: '',
      treeData: [],
      treeProps: { children: 'childNods', label: 'label' }
    }
  },
  computed: {
    resizeCache: {
      get() {
        return LocalStorageUtilsNew.getConfiguration('jmReportResizeCache') || {}
      },
      set(val) {
        LocalStorageUtilsNew.setConfiguration('jmReportResizeCache', val || {})
      }
    },
    isReportTab() {
      return !!(this.$route && this.$route.query && this.$route.query.reportPath)
    },
    reportPath() {
      return this.appendToken((this.$route && this.$route.query && this.$route.query.reportPath) || '')
    }
  },
  watch: {
    filterText(val) {
      if (this.$refs.tree) {
        this.$refs.tree.filter(val)
      }
    }
  },
  mounted() {
    if (!this.isReportTab) {
      this.fetchTree()
    }
  },
  methods: {
    toDesignReport() {
      const cargo = process.env.VUE_APP_CARGO || ''
      const url = this.appendToken(`${cargo}/jmreport/list`)
      window.open(url, '_blank')
    },
    async fetchTree() {
      this.loading = true
      try {
        const res = await getJmReportMenuTree(JM_REPORT_MENU_ID)
        const data = res && res.data
        const list = Array.isArray(data) ? data : ((data && Array.isArray(data.data)) ? data.data : [])
        this.treeData = filterMenuTreeByPermission(list, this.hasMenuPermission)
      } catch (e) {
        // Keep UI usable even if API fails.
        const msg = (e && e.message) ? e.message : '加载失败'
        this.$message && this.$message.error(msg)
      } finally {
        this.loading = false
      }
    },
    hasMenuPermission(code) {
      const roles = (this.$store && this.$store.getters && this.$store.getters.roles) || []
      return !!code && (roles.includes(code) || checkPermission([code]))
    },
    filterNode(value, data) {
      if (!value) return true
      const label = (data && data.label) ? String(data.label) : ''
      return label.toLowerCase().includes(String(value).toLowerCase())
    },
    onNodeClick(data) {
      if (data && data.path) {
        this.openReportTab(data)
      }
    },
    getSessionId() {
      const getters = (this.$store && this.$store.getters) || {}
      const userInfo = getters.userInfo || getUserInfo() || {}
      return getters.token || userInfo.sessionId || getToken()
    },
    appendToken(path) {
      // 剥旧拼新：避免路由 query 里烘焙的旧 token 一直被沿用（BUG-0023）
      return appendCurrentToken(path, this.getSessionId())
    },
    openReportTab(data) {
      const key = data.uuid || data.menuId || data.code || data.path
      this.$router.push({
        name: this.$route.name,
        query: {
          openNew: true,
          key,
          title: data.label || data.chineseLabel || data.code || '报表',
          reportPath: this.appendToken(data.path)
        }
      })
    }
  }
}
</script>

<style scoped>
.jmreport-left {
  width: 100%;
  height: 100%;
  min-width: 190px;
  padding: 8px;
  background-color: #F5F7FA;
  box-sizing: border-box;
  overflow: hidden;
}

.jmreport-report-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
}

.jmreport-report-page__iframe {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.jmreport-left__filter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
}

.jmreport-left__search {
  flex: 1;
}

.jmreport-left__tree {
  height: calc(100% - 40px);
  overflow: auto;
  background: transparent;
}

.jmreport-right {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.jmreport-right__header {
  padding: 10px 12px;
  border-bottom: 1px solid #EBEEF5;
  background: #fff;
  box-sizing: border-box;
}

.jmreport-right__title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.jmreport-right__path {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  word-break: break-all;
}

.jmreport-right__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  background: #fff;
}

.jmreport-right__iframe {
  flex: 1;
  width: 100%;
  border: 0;
  background: #fff;
}
</style>
